import React from 'react'
import PropTypes from 'prop-types'
import cx from 'classnames'

import { HEADLINE_TYPES } from './headline-types'

import styles from './headline.module.css'

/**
 * @property {string}[props.className] - additional css selectors to extend the headline
 * @property {Boolean}[props.multiLine=false] - if set to true the headline is able to show the text over more than one line
 * @property {string}[props.type=HEADLINE_TYPES.head1] - Defines the type of Headline (see also HEADLINE_TYPES)
 * @property {Boolean}[props.showTooltip=false] - Flag to show a tooltip for truncated texts (should be automated in future)
 * @property {string}[props.tooltipLocation=bottom] - Flag for tooltip position (bottom/top) (should be automated in future)
 *
 */
const propTypes = {
    className: PropTypes.string,
    multiLine: PropTypes.bool,
    type: PropTypes.string,
    showTooltip: PropTypes.bool,
    tooltipLocation: PropTypes.string
}

const defaultProps = {
    multiLine: false,
    type: HEADLINE_TYPES.head1,
    showTooltip: false,
    tooltipLocation: 'bottom'
}

function getHeadlineTag(type) {
    switch (type) {
        case HEADLINE_TYPES.title:
            return 'h1'
        case HEADLINE_TYPES.head1:
            return 'h1'
        case HEADLINE_TYPES.head2:
            return 'h2'
        case HEADLINE_TYPES.head3:
            return 'h3'
        case HEADLINE_TYPES.head4:
            return 'h4'
        case HEADLINE_TYPES.head5:
            return 'h5'
        case HEADLINE_TYPES.subHead1:
            return 'h5'
        case HEADLINE_TYPES.subHead2:
            return 'h6'
        default:
            return 'h2'
    }
}

function Headline(props) {
    const { children, className, multiLine, showTooltip, tooltipLocation, type, ...restProps } = props
    const HeadlineTag = getHeadlineTag(type)

    const combinedClassNames = cx(
        styles[type],
        {
            [styles['single-line']]: !multiLine
        },
        {
            [styles['has-tooltip']]: showTooltip
        },
        {
            [styles[`on-${tooltipLocation}`]]: showTooltip
        },
        className,
        `t3sel-atom-headline-${type}`
    )
    const tooltip = showTooltip ? String(children) : null
    return (
        <HeadlineTag data-tooltip={tooltip} className={combinedClassNames} {...restProps}>
            {children}
        </HeadlineTag>
    )
}

Headline.propTypes = propTypes
Headline.defaultProps = defaultProps

export { Headline }
